import i18nFactory from '@yandex-int/i18n';

import {
    addAdGroupMinusKeywordsMutation,
    addKeywordsMutation,
    deleteKeywords,
    replaceKeywordsMutation,
    suspendKeywords,
    unsuspendKeywords,
    updateKeywords
} from '../../../graphql/mutations/grid/phrase';
import { ApiMethodExecutingError } from '../../../service/Errors';
import { getErrorMessage } from '../../../service/GraphqlErrorHelper/GraphqlErrorHelper';
import { rumCounters } from '../../../service/RUM/RUM';
import {
    AddAdGroupMinusKeywordsMutation,
    AddKeywordsMutation,
    DeleteKeywordsMutation,
    FindAndReplaceKeywordsMutation,
    GdAddAdGroupMinusKeywordsInput,
    GdAddKeywordsInput,
    GdDeleteKeywordsInput,
    GdFindAndReplaceKeywordsInput,
    GdSuspendKeywordsInput,
    GdUnsuspendKeywordsInput,
    GdUpdateKeywordsInput,
    SuspendKeywordsMutation,
    UnsuspendKeywordsMutation,
    UpdateKeywordsMutation
} from '../../../typings/graphql-grid';
import { BaseMutationExecutor } from '../../BaseMutationExecutor/BaseMutationExecutor';

import * as keyset from './PhrasesMutationExecutor.i18n';

const i18n = i18nFactory(keyset);

export class PhrasesMutationExecutor extends BaseMutationExecutor {
    public async findAndReplaceKeywords(
        input: GdFindAndReplaceKeywordsInput,
        login: string
    ): Promise<FindAndReplaceKeywordsMutation> {
        const data = await this.awaitExecute<FindAndReplaceKeywordsMutation>(
            replaceKeywordsMutation,
            input,
            login,
            {},
            rumCounters.backendSearchAndReplaceKeyWords
        );

        const { validationResult } = data.findAndReplaceKeywords;

        if (validationResult && validationResult.errors.length) {
            const [firstError] = validationResult.errors;
            throw new ApiMethodExecutingError(getErrorMessage(firstError));
        }

        if (data.findAndReplaceKeywords.updatedTotalCount === 0) {
            throw new ApiMethodExecutingError(i18n('no-phrases-for-replace'));
        }

        return data;
    }

    public deleteKeywords(input: GdDeleteKeywordsInput, login: string) {
        return this.awaitExecute<DeleteKeywordsMutation>(
            deleteKeywords,
            input,
            login,
            {
                notPoliteMutation: true
            },
            rumCounters.backendKeywordsDelete
        );
    }

    public unsuspendKeywords(input: GdUnsuspendKeywordsInput, login: string) {
        return this.awaitExecute<UnsuspendKeywordsMutation>(
            unsuspendKeywords,
            input,
            login,
            {
                notPoliteMutation: true
            },
            rumCounters.backendUnsuspendKeywords
        );
    }

    public suspendKeywords(input: GdSuspendKeywordsInput, login: string) {
        return this.awaitExecute<SuspendKeywordsMutation>(
            suspendKeywords,
            input,
            login,
            {
                notPoliteMutation: true
            },
            rumCounters.backendSuspendKeywords
        );
    }

    public updateKeywords(input: GdUpdateKeywordsInput, login: string) {
        return this.awaitExecute<UpdateKeywordsMutation>(
            updateKeywords,
            input,
            login,
            {
                notPoliteMutation: true
            },
            rumCounters.backendUpdateKeywords
        );
    }

    public addKeywords(
        input: GdAddKeywordsInput,
        login: string
    ): Promise<AddKeywordsMutation> {
        return this.awaitExecute<AddKeywordsMutation>(
            addKeywordsMutation,
            input,
            login,
            {
                notPoliteMutation: true
            },
            rumCounters.backendAddKeywords
        );
    }

    public addAddGroupMinusKeywords(
        input: GdAddAdGroupMinusKeywordsInput,
        login: string
    ): Promise<AddAdGroupMinusKeywordsMutation> {
        return this.awaitExecute<AddAdGroupMinusKeywordsMutation>(
            addAdGroupMinusKeywordsMutation,
            input,
            login,
            {
                notPoliteMutation: true
            },
            rumCounters.backendAddGroupMinusKeywords
        );
    }
}
